var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceMaleInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 41c-5.96 0-10.396-.536-15.403-2.1A22.437 22.437 0 010 22.5C0 10.073 10.073 0 22.5 0 34.926 0 45 10.073 45 22.5a22.437 22.437 0 01-7.097 16.4C32.589 41.625 28.459 41 22.5 41z",
    fill: "#E5E7EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.66 34.287l-2.432-1.358a10.041 10.041 0 01-4.08-4.265c1.233-1.789 2.035-4.058 2.135-5.942h.011l.673-3.008a1.562 1.562 0 00-.673-1.646v-1.09c0-3.113-2.096-6.667-4.953-7.79l.005-.008c-1.405-.634-3.317-.592-4.212-.359.924.332 1.418 1.279.212 1.713h.012a6.792 6.792 0 00-4.652 6.444v1.09a1.56 1.56 0 00-.672 1.646l.672 3.007h.011c.1 1.885.902 4.154 2.136 5.943a10.044 10.044 0 01-4.08 4.265l-2.432 1.358a10.038 10.038 0 00-4.24 4.609A22.411 22.411 0 0022.5 44.999c5.96 0 11.373-2.32 15.399-6.103a10.036 10.036 0 00-4.24-4.609z",
    fill: "#9EA5AD"
  })));
}
export default SvgVoiceMaleInactive;